import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_window",
  "use": "icon-ic_window-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ic_window\">\r\n<path d=\"M4.29224 10.2819V17.8639L12.5992 17.5532V8.55604L4.29224 10.2817V10.2819ZM16.0969 7.58961V17.3808L30.7549 16.8401V4.54639L16.0969 7.58964V7.58961ZM4.29224 21.1432V28.7252L12.5992 30.4511V21.4539L4.29224 21.1432ZM16.0969 21.6263V31.4175L30.7549 34.4608V22.1671L16.0969 21.6264V21.6263Z\" fill=\"white\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol